export const branchList = [
    {
        key: 1,
        value: "CSE",
    },

    {
        key: 2,
        value: "ECE",
    },

    {
        key: 3,
        value: "EEE",
    },

    {
        key: 4,
        value: "ME",
    },

    {
        key: 5,
        value: "CE",
    },

    {
        key: 6,
        value: "MME",
    },

    {
        key: 7,
        value: "PIE",
    },

    {
        key: 8,
        value: "MCA",
    },

    {
        key: 9,
        value: "MTECH",
    },

    {
        key: 10,
        value: "BSC",
    },
];